/* import __COLOCATED_TEMPLATE__ from './dropdown.hbs'; */
var _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@ember/component';
import { action, set } from '@ember/object';
import { inject as service } from '@ember/service';
let Dropdown = (_class = class Dropdown extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "screen", _descriptor, this);
    _defineProperty(this, "tagName", '');
    _defineProperty(this, "isActive", false);
    _defineProperty(this, "closeListener", void 0);
  }
  toggleDropdown(event) {
    set(this, 'isActive', !this.isActive);
    // The attachCloseListener fires the parent click listen event and
    // immediately closes the dropdown becauses it's active.
    // We add the stop propagation here to prevent that.
    event.stopPropagation();
  }
  attachCloseListener() {
    this.closeListener = makeCloseListener().bind(this);
    window.addEventListener('click', this.closeListener);
  }
  closeDropdown() {
    set(this, 'isActive', false);
  }
  willDestroyElement() {
    super.willDestroyElement();
    window.removeEventListener('click', this.closeListener);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "screen", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "toggleDropdown", [action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleDropdown"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "attachCloseListener", [action], Object.getOwnPropertyDescriptor(_class.prototype, "attachCloseListener"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeDropdown", [action], Object.getOwnPropertyDescriptor(_class.prototype, "closeDropdown"), _class.prototype), _class);
export { Dropdown as default };
function makeCloseListener() {
  return function onClose(event) {
    if (!event.target) {
      return;
    }

    // We always want to close the dropdown if it is open and
    // if there is a click on the page
    if (this.isActive) {
      this.closeDropdown();
    }
  };
}